import * as React from "react";
import * as _ from "lodash";
import {
    UserTrackableSymptomUpsertRequest,
    TrackableSymptomViewModel
} from "@curefit/gmf-common";
import CustomSelect from "../CustomSelect";
import AppUtils from "../../utils/AppUtils";
import DurationComponent from "../DurationComponent";
import ModelFactory from "../../models/ModelFactory";
import IStaticDataValue from "../../../../common/models/IStaticDataValue";
import {AppConstants} from "../../utils/AppConstants";
import {TypeAheadElement} from "../TypeAhead";

export interface TrackableSymptomItemEditorProps {
    item: UserTrackableSymptomUpsertRequest;
    onDataChange: (update: any) => any;
    staticTrackableSymptoms: TrackableSymptomViewModel[]
}

export default class TrackableSymptomItemEditor extends React.Component<TrackableSymptomItemEditorProps> {

    _handleUpdateDropdown = (item: string) => {
        const selectedSymptom = this.props.staticTrackableSymptoms.find(symptom => symptom.internalValue === item);
        if (!_.isEmpty(selectedSymptom)) {
            let updatedItem = AppUtils.getDeepCopiedObject(this.props.item);
            updatedItem.userTrackableSymptomObj.symptomDisplayValue = selectedSymptom.displayValue;
            updatedItem.userTrackableSymptomObj.symptomInternalValue = selectedSymptom.internalValue;
            this.props.onDataChange(updatedItem);
        }
    };

    _getDropDownValues = () => {
        if (AppUtils.isDefined(this.props.staticTrackableSymptoms)) {
            return this.props.staticTrackableSymptoms.map(symptom => {
                return {
                    displayValue: symptom.displayValue,
                    internalValue: symptom.internalValue
                }
            })
        } else return []
    };

    generateFrequencyListItems() {
        let frequencyList: IStaticDataValue[] = [];
        _.map(AppConstants.FrequencyUnit, (type, key) => {
            let medicineFrequency = ModelFactory.createNewStaticItem();
            medicineFrequency.internalValue = key;
            medicineFrequency.displayValue = type;
            frequencyList.push(medicineFrequency);
        });
        return frequencyList;
    }

    _handleSymptomFreqChange = (elem: TypeAheadElement) => {
        let updatedItem = AppUtils.getDeepCopiedObject(this.props.item);
        updatedItem.userTrackableSymptomObj.freq = elem.others.value;
        this.props.onDataChange(updatedItem);
    };

    render () {
        const dropDownSymptomsValues = this._getDropDownValues();
        const {userTrackableSymptomObj} = this.props.item;
        const isDisabled = AppUtils.isDefined(userTrackableSymptomObj._id);
        const isCancelled = userTrackableSymptomObj.status === "DELETED";
        const hasFrequency = !_.isEmpty(userTrackableSymptomObj.freq);
        return (
            <div className={`trackable-symptom-item-editor ${isDisabled ? "read-only" : ""} ${isCancelled ? "cancelled" : ""}`}>
                <div className={"trackable-symptoms-drop-down"}>
                    <CustomSelect dropdownValues={dropDownSymptomsValues} selectedValue={userTrackableSymptomObj.symptomDisplayValue} defaultValue={null} updateDropdownValue={this._handleUpdateDropdown} disabled={isDisabled}/>
                </div>
                <div className={"trackable-symptoms-frequency"}>
                    <DurationComponent
                        unit={hasFrequency ? userTrackableSymptomObj.freq.unit : null}
                        count={hasFrequency ? userTrackableSymptomObj.freq.count : null}
                        dropdownItems={this.generateFrequencyListItems()}
                        rootClass={"trackable-symptoms-frequency-dropdown"}
                        isFrequency={true}
                        disabled={isDisabled}
                        onDurationChange={this._handleSymptomFreqChange}
                    />
                </div>
            </div>
        )
    }
}